import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import { Grid } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    maxWidth: 600,
    flexGrow: 1,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  bottomMargin: {
    marginBottom: theme.spacing(2),
  },
});

class ConfirmDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { open, onClose, title, msg } = this.props;

    return (
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={open}
        // disableBackdropClick={disableBackdrop}
        // disableEscapeKeyDown={disableBackdrop}
      >
        <DialogTitle id="customized-dialog-title">{title}</DialogTitle>
        <DialogContent>{msg}</DialogContent>
        <DialogActions>
          <Grid container justify="center">
            <Button onClick={(e) => onClose(e, 'Y')} color="primary">
              Confirm
            </Button>
            <Button onClick={(e) => onClose(e, 'N')} autoFocus>
              Cancel
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(ConfirmDialog);
